import selectn    from 'selectn'
import translate  from '../../../utils/translate'

export const eventSummary = {

  getSummaryTypes : function ( sport = 'rugby' ) {

    let summaryDetails = {
      1 : 'tries',
      2 : 'conversiongoals',
      3 : 'penalties',
      4 : 'dropgoalsconverted',
      //5 : 'yellowcards',
      6 : 'redcards'
    }

    if( sport == 'rugby-league' ) {
      summaryDetails = {
        1 : 'tries',
        2 : 'conversiongoals',
        3 : 'penalties',
        4 : 'dropgoalsconverted',
        6 : 'redcards',
        24 : 'tries',
        26 : 'tries'
      }
    }

    return summaryDetails
  },

  getSummaryFromDetails : function ( sport = 'rugby', edition = {}, competitiors = [], details = [] ) {

    const summaryDetails  = eventSummary.getSummaryTypes( sport )
    const teamAHomeAway   = selectn( '[0].homeAway', competitiors ) || 'home'
    const homeTeamId      = teamAHomeAway === 'home' ? selectn( '[0].id', competitiors ) : selectn( '[1].id', competitiors )
    const detsLen         = details.length || 0
    const players         = {
      home : {
        squad: [],
        playerMap: {}
      },
      away : {
        squad: [],
        playerMap: {}
      },
      penalties : {
        home : [],
        away : []
      }
    }

    for (let i = 0; i < detsLen; i++) {
      const detail = details[i]
      const detailType = selectn( 'type.id', detail )
      const eventTime   = selectn( 'clock.displayValue', detail ) || 0

      if ( typeof summaryDetails[detailType] !== 'undefined' ) {
        const athleteId   = selectn( 'athletesInvolved[0].id', detail ) || 0
        const athleteName = selectn( 'athletesInvolved[0].displayName', detail ) || '-'
        const athleteLink = selectn( 'athletesInvolved[0].links[0].href', detail ) || ''

        const homeAway    = selectn( 'team.id', detail ) === homeTeamId ? 'home' : 'away'

        if ( typeof players[homeAway].playerMap[athleteId] === 'undefined' ) {
          players[homeAway].playerMap[athleteId] = players[homeAway].squad.length
          players[homeAway].squad.push({
            name        : athleteName,
            url         : athleteLink,
            eventTimes  : {}
          })
        }
        const currPlayer = players[homeAway].squad[ players[homeAway].playerMap[athleteId] ]
        if( typeof currPlayer.eventTimes[ detailType ] === 'undefined' ) {
          currPlayer.eventTimes[ detailType ] = []
        }

        currPlayer.eventTimes[ detailType ].push( eventTime )
      } else if ( detailType == 14 ) {
        const penTeamId = selectn( 'team.id', detail ) || 0
        if ( homeTeamId == penTeamId ) {
          players.penalties.home.push( eventTime )
        } else {
          players.penalties.away.push( eventTime )
        }
      }
    }

    return eventSummary.getMatchSummary( sport, edition, players )
  },

  getMatchSummary : function ( sport = 'rugby', edition = {}, data = {} ) {

    const homeSquad = selectn('home.squad', data) || []
    const awaySquad = selectn('away.squad', data) || []
    const homePens  = selectn('penalties.home', data) || []
    const awayPens  = selectn('penalties.away', data) || []

    return {
      home : eventSummary.getTeamSummary( sport, edition, homeSquad, homePens ),
      away : eventSummary.getTeamSummary( sport, edition, awaySquad, awayPens )
    }

  },

  getTeamSummary : function ( sport = 'rugby', edition = {}, data = [], pens = [] ) {

    const summaryDetails  = eventSummary.getSummaryTypes( sport )
    const iSquadLen       = data.length || 0
    let summary           = {}

    //for each type check the every player to see if we have the data.
    for (let stat in summaryDetails) {

      for (let i = 0; i < iSquadLen; i++) {

        const eventTimes = selectn( '[' + i + '].eventTimes.'+stat, data ) || []
        if( eventTimes.length >= 1 ) {

          eventTimes.sort( function ( a, b ) {
            const aVal = parseInt(a.replace(/\D+/g, '')) || 0
            const bVal = parseInt(b.replace(/\D+/g, '')) || 0
            return aVal - bVal
          } ) /* sort times */
          if( typeof summary[summaryDetails[stat]] === 'undefined' ) {
            summary[summaryDetails[stat]] = []
          }
          // If player has multiple summaryDetails stats, group and sort stats to single player stats.
          let hasSimilarName = false
          if(summary[summaryDetails[stat]].length) {
            for (var k in summary[summaryDetails[stat]]) {
              if (selectn('name', summary[summaryDetails[stat]][k]) === selectn('[' + i + '].name', data)) {
                summary[summaryDetails[stat]][k].times.push(eventTimes.join(''))
                hasSimilarName = true
                summary[summaryDetails[stat]][k].times.sort( function (a, b) {
                  const aVal = parseInt(a.replace(/\D+/g, '')) || 0
                  const bVal = parseInt(b.replace(/\D+/g, '')) || 0
                  return aVal - bVal
                })
              }
            }
          }
          if (!hasSimilarName) {
            summary[summaryDetails[stat]].push({
              name    : selectn('[' + i + '].name', data) || '',
              times   : eventTimes,
              link    : selectn('[' + i + '].url', data) || '',
              rawClock: 0
            })
          }
        }
      }

      if( typeof summary[summaryDetails[stat]] != 'undefined' ) {
        summary[summaryDetails[stat]].sort( function ( a, b ) {
          const aVal = parseInt(a.times[0].replace(/\D+/g, '')) || 0
          const bVal = parseInt(b.times[0].replace(/\D+/g, '')) || 0
          return aVal - bVal
        } )
      }
    }

    if( pens.length >= 1 ) {
      if( typeof summary['tries'] === 'undefined' ) {
        summary['tries'] = []
      }
      summary['tries'].push({
        name    : translate(edition, 'Penalty Try'),
        times   : pens,
        link    : '#',
        rawClock: 0
      })
    }

    return summary
  }

}

export default eventSummary



// WEBPACK FOOTER //
// ../app/lib/transform/parsers/rugby/eventSummary.js